import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Product} from '@app/@core/@models/design/product.model';
import {FormControl} from '@angular/forms';
import {AdvertDraft} from '@app/@core/advertising/campaign/advert/advert-draft';
import { Uuid } from '@shared/utils/uuid';
import { ConfigService } from '@app/@core/@config/config.service';
import { BestResults } from '@app/@core/@config/registered-urls-data';
import { LayoutComponent } from '@app/@core/@models/advertising/layout/layout-component.model';
import { AspectRatio, AssetComponent } from '@app/@core/@models/advertising/layout/asset-component.model';
import { Layout } from '@app/@core/@models/advertising/layout/layout.model';

@Component({
  selector: 'app-ad-size-selector[product][advertDraft]',
  templateUrl: './ad-size-selector.component.html',
  styleUrls: ['./ad-size-selector.component.scss']
})
export class AdSizeSelectorComponent implements OnInit, OnChanges {
  @Input() product!: Product;
  @Input() advertDraft!: AdvertDraft;
  control!: FormControl<string>;
  uuid: string = Uuid.generate();
  aspectRatio: AspectRatio | undefined;

  constructor(private configService: ConfigService) {
  }

  ngOnInit(): void {
    if (!this.advertDraft.advertForm.controls.creativeSize.value) {
      this.advertDraft.advertForm.controls['creativeSize'].setValue(this.getAllowedCreativeSizes()[0]);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.control = this.advertDraft.advertForm.controls.creativeSize;

    const ac = this.advertDraft.advertForm.controls.layoutComponents.value.map((lc) => {
      return lc.layoutComponent;
    }).find((val) => {
      return val && val.type === 'ASSET' && (val as AssetComponent).aspectRatio && val.tag === 'image';
    }) as AssetComponent;
    this.aspectRatio = ac && ac.aspectRatio ? ac.aspectRatio : undefined;
  }

  getAllowedCreativeSizes(): string[] {
    return this.advertDraft.campaignDraft.campaignDraftFactory.allowedCreativeSizes(this.product);
  }
}
